var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
var mapStateToProps = function (state) { return ({
    photoUpload: state.cartItemEditor.photoUpload,
}); };
var connector = connect(mapStateToProps, {});
var UploadLoader = /** @class */ (function (_super) {
    __extends(UploadLoader, _super);
    function UploadLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadLoader.prototype.render = function () {
        if ('loading' !== this.props.photoUpload.status || 0 === this.props.photoUpload.uploadProgress.total) {
            return null;
        }
        return (React.createElement("div", { className: "c-upload-loader__wrapper" },
            React.createElement("div", { className: "c-upload-loader" },
                React.createElement("div", { className: "c-upload-loader__progress" }, this.renderProgressRing()),
                React.createElement("div", { className: "c-upload-loader__status" }, this.renderProgress())),
            React.createElement("div", { className: "c-upload-loader__text" }, this.props.t('upload_loader.text'))));
    };
    UploadLoader.prototype.renderProgressRing = function () {
        var radius = 63;
        var stroke = 10;
        var normalizedRadius = radius - stroke / 2;
        var circumference = normalizedRadius * 2 * Math.PI;
        var progress = Math.floor(this.props.photoUpload.uploadProgress.loaded / this.props.photoUpload.uploadProgress.total * 100);
        var strokeDashoffset = circumference - progress / 100 * circumference;
        return (React.createElement("svg", { height: radius * 2, width: radius * 2 },
            React.createElement("circle", { stroke: "#E66DA7", fill: "transparent", strokeWidth: stroke, strokeDasharray: circumference + ' ' + circumference, style: { strokeDashoffset: strokeDashoffset }, r: normalizedRadius, cx: radius, cy: radius })));
    };
    UploadLoader.prototype.renderProgress = function () {
        if (!this.props.photoUpload.uploadProgress) {
            return null;
        }
        if (!this.props.photoUpload.uploadProgress.total) {
            return null;
        }
        var percent = Math.floor(this.props.photoUpload.uploadProgress.loaded / this.props.photoUpload.uploadProgress.total * 100);
        return (React.createElement("div", { className: "c-upload-loader__content__progress" },
            percent,
            "%"));
    };
    return UploadLoader;
}(React.Component));
export default connector(withTranslation()(UploadLoader));
